// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23knX","tabsBox":"styles_tabsBox__3BU3O","createButton":"styles_createButton__1ZVAE"};